import React from 'react';

const LiveWins = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.9993 2.6665C8.63935 2.6665 2.66602 8.63984 2.66602 15.9998C2.66602 23.3598 8.63935 29.3332 15.9993 29.3332C23.3593 29.3332 29.3327 23.3598 29.3327 15.9998C29.3327 8.63984 23.3593 2.6665 15.9993 2.6665ZM19.546 18.3065L17.8393 19.2932L16.1327 20.2798C13.9327 21.5465 12.1327 20.5065 12.1327 17.9732V15.9998V14.0265C12.1327 11.4798 13.9327 10.4532 16.1327 11.7198L17.8393 12.7065L19.546 13.6932C21.746 14.9598 21.746 17.0398 19.546 18.3065Z",
      fill: "#00FFFF"
    }
  )
);

export { LiveWins };
//# sourceMappingURL=LiveWins.js.map
